import React, { useEffect } from 'react';
import Routes from './routes';
import Footer from './components/Footer';
import Contacts from './components/Contacts';
import Container from 'react-bootstrap/esm/Container';
import ReactGA from 'react-ga';

function App() {
   useEffect(() => {
      ReactGA.initialize('UA-46738300-15')
      ReactGA.pageview('/')
   }, [])
   return (
      <div className="App">         
         <Routes />
            <div className="pt-5 mt-5" />
         <Container>
            <Contacts />
         </Container>        
         <Footer />
      </div>
   );
}
export default App;